import React from 'react';
import { bool, func, shape, string } from 'prop-types';
import { Card } from '@thd-olt-component-react/card';
import { SEOContent } from './SEOContent';

export const QuestionsAndAnswersMobile = ({
  canonicalUrl, itemId, loadBV, productLabel, questionsAnswers, wwwHost
}) => {

  let maxHeight;
  const { Results } = questionsAnswers;
  if (!Results.length) {
    maxHeight = '200px';
  }
  let url = '#';
  if (canonicalUrl) {
    const [withoutQuery] = (canonicalUrl).split('?');
    const path = withoutQuery.replace('/p', '');
    const questionPath = `/p/questions${path}/1`;
    url = typeof window === 'undefined' ? `${wwwHost}${questionPath}` : questionPath;
  }

  const cardClicked = (evt, overlayScroll) => {
    const { target } = evt || {};
    const { name = '' } = target || {};
    const ask = /BV_TrackingTag_QA_Display_AskQuestion|BV_TrackingTag_QA_Display_AskFirstQuestion/i.test(name);
    if (!ask && !overlayScroll) {
      if (document.getElementById('BVQAScript')) {
        let script = document.getElementById('BVQAScript');
        script.parentElement.removeChild(script);
      }
      if (evt.preventDefault) {
        evt.preventDefault();
      }
      loadBV();
    } else {
      window.history.pushState({}, 'Overlay', '#overlay');
      if (evt.stopPropagation) {
        evt.stopPropagation();
      }
      if (overlayScroll) document.body.classList.toggle('body--noscroll', false);
    }
  };

  return (
    <Card noHide className="questions-and-answers">
      <Card.Content maxHeight={maxHeight} className="questions-and-answers-card-content">
        <a href={url} onClick={(evt) => cardClicked(evt, false)}>
          <div className="row-header row-header--nomargin row-header--space-between questions-and-answers__title">
            <div className="row-header__title">
              <span className="row-header__text">Questions &amp; Answers</span>
            </div>
            <span><img src="https://assets.homedepot-static.com/images/v1/caret-orange.svg" alt="More" /></span>
          </div>
          <div id="BVQAContainer">
            <div className="questions-and-answers__seo-content">
              <SEOContent questionsAnswers={questionsAnswers} itemId={itemId} productLabel={productLabel} />
            </div>
          </div>
        </a>
        <Card.Content.Overlay>
          <button type="button" className="col-12 card" onClick={(evt) => cardClicked(evt, true)}>
            <div className="row-header">
              <div className="row-header__title">
                <h2 className="row-header__text">Questions &amp; Answers</h2>
              </div>
            </div>
            <div id="BVQAContainer" />
          </button>
        </Card.Content.Overlay>
      </Card.Content>
    </Card>
  );

};

QuestionsAndAnswersMobile.displayName = 'QuestionsAndAnswersMobile';

QuestionsAndAnswersMobile.propTypes = {
  canonicalUrl: string,
  itemId: string.isRequired,
  loadBV: func.isRequired,
  productLabel: string,
  questionsAnswers: shape({}).isRequired,
  wwwHost: string,
};

QuestionsAndAnswersMobile.defaultProps = {
  canonicalUrl: null,
  productLabel: null,
  wwwHost: 'https://www.edge-pr.homedepot.com'
};
